module.exports = __webpack_public_path__ + "static/icon-interactivity-413b902ac66e0c9d0bfb84793c9c0a5e.svg";